import { lazy } from "react";
// ===========================================================================
// Clinical Note AI — análisis de notas con IA (upload de PDF).
//
// DEV-ONLY: el módulo resuelve su propio gating y en producción NO publica
// rutas (ver common/constants.js). El sidebar usa la misma constante, así que
// las dos caras no pueden desincronizarse.
// ===========================================================================
import { CLINICAL_NOTE_AI_ENABLED } from "./common/constants";

const ClinicalNoteAiPage = lazy(() => import("./pages/ClinicalNoteAiPage"));

export const clinicalNoteAiRoutes = CLINICAL_NOTE_AI_ENABLED
  ? [{ path: "/ClinicalNoteAi", element: <ClinicalNoteAiPage /> }]
  : [];

export { ClinicalNoteAiPage };
export { CLINICAL_NOTE_AI_ENABLED, CLINICAL_NOTE_AI_BASE_PATH } from "./common/constants";
